export default function mapValuesToRequest(provenance: string) {
  return {
    deleted: 0,
    name: provenance,
  }
}
